(function() {
    'use strict';

    angular.module('allegro').controller('AllegroSenderCreateController', AllegroSenderCreateController);

    AllegroSenderCreateController.$inject = [
        '$state',
        '$stateParams',
        'notificationSrvc',
        'errorNotificationSrvc',
        'allegroAccountDataSrvc',
        'allegroSendersDataSrvc',
        'allegroSenderMessagesConst'
    ];

    function AllegroSenderCreateController(
        $state,
        $stateParams,
        notificationSrvc,
        errorNotificationSrvc,
        allegroAccountDataSrvc,
        allegroSendersDataSrvc,
        allegroSenderMessagesConst
    ){
        var self = this;
        self.loading = false;

        self.serverErrors = {
            account: [],
            company_name: [],
            name: [],
            street: [],
            zip_code: [],
            city: [],
            country_code: [],
            email: [],
            phone: []
        };

        self.account = {};
        self.senderData = {
            account: null,
            company_name: '',
            name: '',
            street: '',
            zip_code: '',
            city: '',
            country_code: '',
            email: '',
            phone: '',
        };

        self.getAccount = getAccount;
        self.createSender = createSender;
        self.cleanErrors = cleanErrors;

        active();

        function active(){
            self.getAccount($stateParams.pk);
        }

        function getAccount(accountPk) {
            self.loading = true;

            return allegroAccountDataSrvc.get({pk: accountPk})
                .$promise
                .then(function (response) {
                    self.account = response;
                    return response;
                })
                .catch(function(response) {
                    if (response.status === 404) {
                        notificationSrvc.notification("error", response.data.detail);
                        $state.go('layout.allegro-accounts.list');
                    }
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function createSender() {
            self.senderData.account = self.account.pk;

            allegroSendersDataSrvc.create(self.senderData)
                .$promise
                .then(function(response) {
                    notificationSrvc.notification("success", allegroSenderMessagesConst.add);
                    $state.go('layout.allegro-accounts.detail.settings', {pk: self.account.pk});
                })
                .catch(function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                })
                .finally(function (response) {
                    self.loading = false;
                    return response;
                });
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
